import "./index.scss";

import invariant from "invariant";
import React from "react";
import ReactDOM from "react-dom";

import App from "./app/App";
import Cloudfarm from "./cloudfarm/index";
import CloudfarmLight from "./cloudfarm/light";
import PlantingSeedingTimeline from "./cropfield/planting_seeding_timeline";
import Timeline, { TimelineDetail } from "./cropfield/timeline";
import RainDancer from "./app/raindancer/RainDancer";
import PersonalToken from "./cropletdeveloper/PersonalToken";
import Dashboard from "./dashboard/beta/Dashboard";
import DashboardBarnTile from "./dashboard/DashboardBarnTile";
import DashboardSummaryTile from "./dashboard/summary/DashboardSummaryTile";
import DashboardFinancial from "./dashboard/financial/DashboardFinancial";
import DashboardFinancialCropfield from "./dashboard/financial/DashboardFinancialCropfield";
import DashboardFinancialCropfieldTile from "./dashboard/financial/DashboardFinancialCropfieldTile";
import DashboardFinancialTile from "./dashboard/financial/DashboardFinancialTile";
import ParcelPropertiesModal from "./map/parcel/ParcelPropertiesModal";
import StoragePropertiesModal from "./map/storage/StoragePropertiesModal";
import WayLinePropertiesModal from "./map/wayLine/WayLinePropertiesModal";
import CropFieldPropertiesModal from "./map/cropfield/CropFieldPropertiesModal";
import FileUploadModal from "./fileupload/FileUploadModal";
import FileOverview from "./fileupload/FileOverview";
import SingleFileOverview from "./fileupload/SingleFileOverview";
import GeometryPartPreview from "./shared/components/GeometryPartPreview";
import ImageGallery from "./cropr/settings/ImageGallery/ImageGallery";
import ImportExport from "./cropr/settings/ImportExport/ImportExport";
import AsideGrower from "./app/aside/AsideGrower";
import AsidePartner from "./app/aside/AsidePartner";
import Avatar from "./fileupload/Avatar";
import {
  Sensors as DacomOnlineSensors,
  WeatherData as DacomWeatherData,
  WeatherForecast as DacomWeatherForecast,
  RawData as DacomRawData,
  initialize as dacomOnlineInitialize,
} from "@cropx/dacom-online";

import cropr from "./shared/utils/cropr";
import CropFieldPermissionSelectModal from "./cropr/farmcontact/CropFieldPermissionSelectModal";
import PriorityMeasurementsSelectModal from "./cropr/machines/MeasurementSelectModal";
import NavBar from "./app/navbar/NavBar";
import RecordsTile from "./dashboard/RecordsTile";
import CeresScenarioGrowthGraph from "./dss/ceres/ceresScenarioGrowthGraph";
import CropFieldFinance from "./cropr/CropField/Finance";
import Reports from "./reports/Reports";
import LanguageSwitch from "./shared/components/LanguageSwitch";

const Strict = React.Fragment; //React.StrictMode;

if (document.getElementById("root")) {
  ReactDOM.render(
    <Strict>
      <App />
    </Strict>,
    document.getElementById("root")
  );
}

// React.FC<any>;
type Components = {
  [key: string]: any;
};

// Add components to window object for use in Backbone.
const components: Components = {
  Dashboard,
  DashboardFinancialTile,
  DashboardBarnTile,
  DashboardSummaryTile,
  Timeline,
  TimelineDetail,
  PlantingSeedingTimeline,
  PersonalToken,
  Cloudfarm,
  CloudfarmLight,
  DashboardFinancial,
  DashboardFinancialCropfieldTile,
  DashboardFinancialCropfield,
  ParcelPropertiesModal,
  StoragePropertiesModal,
  WayLinePropertiesModal,
  CropFieldPropertiesModal,
  CropFieldPermissionSelectModal,
  PriorityMeasurementsSelectModal,
  FileUploadModal,
  FileOverview,
  SingleFileOverview,
  RainDancer,
  GeometryPartPreview,
  ImageGallery,
  ImportExport,
  AsideGrower,
  AsidePartner,
  NavBar,
  Avatar,
  RecordsTile,
  CeresScenarioGrowthGraph,
  CropFieldFinance,
  Reports,
  LanguageSwitch,
  DacomOnlineSensors,
  DacomWeatherData,
  DacomWeatherForecast,
  DacomRawData,
};

// If we are on a development environment: Hottify all entry points
if (process.env.NODE_ENV === "development")
  Object.entries(components).forEach(([key, value]) => {
    components[key] = value;
  });

// Add render function to window object for use in Backbone.
window.RenderReactComponent = (component, domNode, props) => {
  let node = typeof domNode === "string" ? document.getElementById(domNode) : domNode;
  if (!node && domNode === "modals") {
    node = document.createElement("div");
    node.setAttribute("id", domNode);
    document.body.appendChild(node);
  }
  if (!node) return console.error("Missing element for RenderReactComponent");
  ReactDOM.unmountComponentAtNode(node);
  const Component = components[component] || console.error("missing component", component);
  invariant(
    Component,
    `React component '${component}' was not defined in components literal object in index.tsx.`
  );

  // Add a div with class "ReactComponent" to apply styles independent of current backbone frontend
  ReactDOM.render(
    <Strict>
      <Component {...props} />
    </Strict>,
    node
  );
  // i hecking love javascript..
  window._ = require("underscore");
};
window._ = require("underscore");

// Remove a React component for use in Backbone.
window.UnmountReactComponent = (domNode) => {
  ReactDOM.unmountComponentAtNode(domNode);
};

// Render other parts of the interface)
cropr?.addInit(function () {
  if (document.getElementById("topbar")) window.RenderReactComponent("NavBar", "topbar", {});
  if (document.getElementById("aside")) window.RenderReactComponent("AsideGrower", "aside", {});
  if (document.getElementById("asidePartner"))
    window.RenderReactComponent("AsidePartner", "asidePartner", {});
});

cropr?.addInit(() => {
  dacomOnlineInitialize(cropr);
});
